import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookPaymentRequest } from '../../requests/platform/book-payment.request';
import { BookPaymentResponse } from '../../responses/platform/book-payment.response';

@Injectable({
  providedIn: 'root'
})
export class BookPaymentService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public postPayment(request: BookPaymentRequest): Observable<BookPaymentResponse> {
    return this.http
      .post<BookPaymentResponse>(
        environment.urlApiPlatform + "BookPayment",
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
